/* eslint-disable */
import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'
// import createLogger from 'vuex/dist/logger'
import hotels from '@/store/hotels.js'
import ombrelloni from '@/store/ombrelloni.js'
import guests from '@/store/guests.js'
import users from '@/store/users.js'
import beach from '@/store/beach.js'

var ls = new SecureLS({ isCompression: false })

Vue.use(Vuex)

export default new Vuex.Store({
  // strict: true,
  modules: {
    hotels,
    ombrelloni,
    guests,
    users,
    beach
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
    // createLogger()
  ],
  state: {
    // jwt: JSON.parse(localStorage.getItem('ombrelleria')),
    jwt: {},
    loading: false,
    inapp: null,
    user: {
      id: null,
      profile: {},
      privileges: {}
    },
    version: {}
  },
  actions: {
    getUser ({commit, state}) {
      console.log('getUser: ')
      commit('SET_LOADING', true)
      Vue.http
        .get(process.env.VUE_APP_API + '/user/me',
        {
          headers: {
            'Authorization': 'Bearer ' + state.jwt.jwt
          }
        },
        ).then(response => {
          // console.log(response.data)
          // commit('LOAD_OMBRELLONI', response.data.ombrells)
          commit('SET_LOADING', false)
          var privileges
          if (state.hotels.activehotel.user === state.user.id) {
            privileges = {
              owner: true,
              admin: true
            }
          } else {
            privileges = _.find(response.data.profile.hotels, {hotelid: state.hotels.activehotel._id}).privileges
          }
          // console.log('store privileges: ', privileges)
          commit('SET_PRIVILEGES', privileges)
          commit('SET_PROFILE', response.data)
        }, error => {
          console.log('getUser', error)
          localStorage.clear()
          window.location.replace('/login')
        })
    },
    checkForUpdates ({commit, state, rootState}, data) {
      // console.log('updateOmbrelloni: ', data)
      // commit('SET_LOADING', true)
      return new Promise((resolve, reject) => {
        Vue.http
          .get(process.env.VUE_APP_API + '/api/appversion',
          {
            headers: {
              'Authorization': 'Bearer ' + rootState.jwt.jwt
            }
          },
          ).then(response => {
            // console.log(response)
            // resolve('ok')
            if (state.version.build === undefined || state.version.build.number === undefined) {
              console.warn('need to set version')
              // commit('SET_VERSION', response.data)
              resolve({updateExists: true, version: response.data})
            } else if (state.version.build.number !== response.data.build.number) {
              resolve({updateExists: true, version: response.data})
            } else {
              resolve({updateExists: false})
            }
            // console.warn(state.version.build.number)
            // if (!state.version.build.number || state.version.build.number === undefined) {
            //   console.warn('need to set version')
            //   commit('SET_VERSION', response.data)  
            // }
            // commit('SET_VERSION', response.data)
          }, error => {
            reject(error)
            // commit('SET_LOADING', false)
            // this._vm.$notify({
            //   title: 'Errore connessione',
            //   message: 'prego riprovare',
            //   type: 'error'
            // })
          })
      })
    }
  },
  mutations: {
  	LOAD_JWT (state, response) {
  		// console.log('store: ', response)
  		state.jwt = response
      state.user.id = response.user
      state.user.profile = response.profile
      state.user.profile.email = response.email
    },
    SET_PRIVILEGES (state, data) {
      state.user.privileges = data
    },
    SET_GUEST (state, data) {
      state.user.privileges.guest = data
    },
    SET_PROFILE (state, data) {
      state.user.profile = data.profile
      state.user.profile.email = data.email
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    SET_INAPP (state, data) {
      state.inapp = data
    },
    SET_VERSION (state, data) {
      state.version = data
    },
    RESET_VERSION (state) {
      state.version = {}
    },
  },
  getters: {
	jwt: state => {
		if (state.jwt) {
			return state.jwt.jwt
		} else {
			// localStorage.clear()
			return null
		}
	}
  }
})
